import { Api } from 'models/services/api';
import { DeleteIngredientCategoryQuery } from 'models/services/graphql';

import { IngredientCategoryData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteIngredientCategory($id: ID!) {
    ${DeleteIngredientCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    deleteIngredientCategory: IngredientCategoryData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: IngredientCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw 'invalid response';
    const document = api.response.data.deleteIngredientCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };